﻿import * as React from 'react';
import { NavLink } from "react-router-dom";

export default function AdministrationLauncher() {
    return (
        <div className="launcher-container">
            <h1 className="main-title">ADMINISTRATION</h1>

            <div className="card-container">
                <NavLink className="pw-card-link" to="/dynamics-items-preparation">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">group</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div id="usersCard" className="pw-card-main-title">DYNAMICS</div>
                            <div className="pw-home-card-text">Dynamics ERP Data Entry</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/users">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">group</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div id="usersCard" className="pw-card-main-title">USERS</div>
                            <div className="pw-home-card-text">Users and Groups management</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/locations-maintenance">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">shelves</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div id="usersCard" className="pw-card-main-title">LOCATIONS</div>
                            <div className="pw-home-card-text">Locations maintenance</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/qualifications-management">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">article_person</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div id="usersCard" className="pw-card-main-title">QUALIFICATIONS</div>
                            <div className="pw-home-card-text">Employee qualifications maintenance</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/tickets">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">assignment_late</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">TICKET LOG</div>
                            <div className="pw-home-card-text">Report tickets and enhancement requests</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/logging-information">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">edit_calendar</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">LOGGING</div>
                            <div className="pw-home-card-text">Logging records and queries</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/audithistory">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">restore</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">AUDIT DATA</div>
                            <div className="pw-home-card-text">Audit records</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/safety-launcher">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">health_and_safety</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">SAFETY</div>
                            <div className="pw-home-card-text">Safety categories and configurations</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">settings</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">SETTINGS</div>
                            <div className="pw-home-card-text">System-level settings</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/packaging-materials-maintenance">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">inventory_2</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">PACKAGING MATERIALS</div>
                            <div className="pw-home-card-text">Packaging materials management</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/sample-types-editor">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">edit_arrow_down</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">SAMPLE TYPES</div>
                            <div className="pw-home-card-text">Sample types management</div>
                        </div>
                    </div>
                </NavLink>


                <NavLink className="pw-card-link" to="/tables-management">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">location_on</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">TABLES MANAGEMENT</div>
                            <div className="pw-home-card-text">Lookup tables management</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/form-configuration">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">list_alt</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">FORM</div>
                            <div className="pw-home-card-text">DMA form and page management</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/enumerations">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">format_list_numbered</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">ENUMERATIONS</div>
                            <div className="pw-home-card-text">Enumerations management</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/documentationlauncher">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">description</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">DMA HELP MANAGEMENT</div>
                            <div className="pw-home-card-text">DMA Help documents and pages management</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/serialization">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">data_object</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">SERIALIZATION</div>
                            <div className="pw-home-card-text">Data serialization</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/software-requirements-form">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">bug_report</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">SOFTWARE REQUIREMENTS</div>
                            <div className="pw-home-card-text">URS and FRS data</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/barcode-reader-demo">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">barcode</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">BAR CODES</div>
                            <div className="pw-home-card-text">Bar code reader and writer</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/pubchem-data-portal">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">science</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">PUBCHEM</div>
                            <div className="pw-home-card-text">Get chemical data via API</div>
                        </div>
                    </div>
                </NavLink>


                <NavLink className="pw-card-link" to="/sample-preparations-demo">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">table</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">Sample Preparations</div>
                            <div className="pw-home-card-text">Proposal and Demo</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/azure-relay">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">balance</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">Azure Relay Demo</div>
                            <div className="pw-home-card-text">Mettler Toledo Balance Demo</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/npi-entry-form-demo">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">mail</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">NPI Entry</div>
                            <div className="pw-home-card-text">NPI Entry Form Demo</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/dynamics-api-demo">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">group</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">Dynamics</div>
                            <div className="pw-home-card-text">API Demo</div>
                        </div>
                    </div>
                </NavLink>

                {/*
                                    <NavLink tag={Link} className="pw-card-link" to="/calculations-testing">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon pw-pink">bug_report</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title pw-pink">TESTING</div>
                        </div>
                    </div>
                </NavLink>

                
                    <NavLink tag={Link} className="pw-card-link" to="/dmaprogressganttchart">
                        <div className="pw-home-page-card">
                            <div className="pw-card-icon-section">
                                <img src={AssetsIcon} alt="gantt" className="pw-card-icon" />
                            </div>

                            <div className="pw-card-data-section">
                                <div className="pw-card-main-title">DMA Progress</div>
                                <div className="pw-card-sub-title">Gantt Chart</div>
                            </div>
                        </div>
                    </NavLink>

                    <NavLink tag={Link} className="pw-card-link" to="/dmaprogressscheduler">
                        <div className="pw-home-page-card">
                            <div className="pw-card-icon-section">
                                <img src={AssetsIcon} alt="gantt" className="pw-card-icon" />
                            </div>

                            <div className="pw-card-data-section">
                                <div className="pw-card-main-title">DMA Progress</div>
                                <div className="pw-card-sub-title">Scheduler</div>
                            </div>
                        </div>
                    </NavLink>
                                        
                    */}

            </div>
        </div>
    );
}